import React from 'react';
import { Rect, Text } from 'react-konva';
import { xFromTimeStyled } from '../../utils';
import { Activity, GraphStyle } from '../../types';
import { KonvaEventObject } from 'konva/lib/Node';


function DataItem({
	start,
	activity,
	highlight,
	disabled,
	onCellEnter,
	onCellLeave,
	onCellClick,
	style,
}: DataItemProps) {

	const xFromTime = xFromTimeStyled(style, start)
	const posX = xFromTime(activity.start)
	if (posX < 0) return null

	// HANDLERs
	const handleEnter = (e: KonvaEventObject<MouseEvent>) => {
		e.cancelBubble = true
		onCellEnter(e)
	}
	const onMouseLeave = (e: KonvaEventObject<MouseEvent>) => {
		e.cancelBubble = true
		onCellLeave(e)
	}

	// RENDER
	let color = style.activity.font.color
	if ( activity.color ) {
		color = {
			default: activity.color,
			highlight: activity.color,
			disabled: activity.color,
		}
	}
	const size = style.activity.font.size

	return (<>
		{highlight && (
			<Rect listening={false} transformsEnabled="position"
				x={posX + 1}
				y={(activity.row * style.space.y) + 1}
				width={style.space.x - 2}
				height={style.space.y - 2}
				stroke={color.highlight}
				strokeWidth={1}
			/>
		)}
		<Text transformsEnabled="position" //listening={false}
			onMouseEnter={handleEnter}
			onMouseLeave={onMouseLeave}
			text={activity.label}
			fontSize={size}
			fill={disabled ? color.disabled : color.default}
			x={posX}
			y={activity.row * style.space.y}
			width={style.space.x}
			height={style.space.y}
			align="center"
			verticalAlign="middle"
		/>
	</>)
}

export default DataItem

type DataItemProps = {
	start?: number,
	activity?: Activity,
	style?: GraphStyle,
	highlight?: boolean,
	disabled?: boolean,
	onCellEnter?:(e: KonvaEventObject<MouseEvent>)=>void,
	onCellLeave?:(e: KonvaEventObject<MouseEvent>)=>void,
	onCellClick?:(e: KonvaEventObject<MouseEvent>)=>void,
}